<template>
  <div>
    <div v-if="form" style="text-align: right;" dir="rtl">
      <div v-if="payload.is_create">
        <p class="bold">Language</p>
        <select dir="rtl" v-model="form.data.language.fields.language_id.value"
          ><option
            :key="'language_' + language.id"
            v-for="language in languages"
            :value="language.id"
            >{{ language.name }}</option
          ></select
        >
      </div>
      <div class="is-flex is-align-items-flex-end">
        <div>
          <p class="bold">Reading</p>
          <select dir="rtl" v-model="form.data.language.fields.reading.value"
            ><option
              :key="'reading_' + option.value"
              v-for="option in options"
              :value="option.value"
              >{{ option.text }}</option
            ></select
          >
        </div>
        <div class="horizontal_space"></div>
        <div class="horizontal_space"></div>
        <checkbox v-model="reading_importance" :checked="form.data.language.fields.reading_importance.value == 8">Importance</checkbox>
      </div>
      <div class="is-flex is-align-items-flex-end">
        <div>
          <p class="bold">Writing</p>
          <select dir="rtl" v-model="form.data.language.fields.writing.value"
            ><option
              :key="'writing_' + option.value"
              v-for="option in options"
              :value="option.value"
              >{{ option.text }}</option
            ></select
          >
        </div>
        <div class="horizontal_space"></div>
        <div class="horizontal_space"></div>
        <checkbox v-model="writing_importance" :checked="form.data.language.fields.writing_importance.value == 8">Importance</checkbox>
      </div>
      <div class="is-flex is-align-items-flex-end">
        <div>
          <p class="bold">Verbal</p>
          <select dir="rtl" v-model="form.data.language.fields.verbal.value"
            ><option
              :key="'verbal_' + option.value"
              v-for="option in options"
              :value="option.value"
              >{{ option.text }}</option
            ></select
          >
        </div>
        <div class="horizontal_space"></div>
        <div class="horizontal_space"></div>
        <checkbox v-model="verbal_importance" :checked="form.data.language.fields.verbal_importance.value == 8">Importance</checkbox>
      </div>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import LanguagesHelper from '@/custom/classes/languages_helper.js'
import Checkbox from '@/components/Checkbox'
export default {
  props: ['payload'],
  name: 'position-languages-form',
  data () {
    let languages_helper = new LanguagesHelper()
    return {
      languages: [],
      company_id: this.payload.company_id,
      form: undefined,
      is_loading: false,
      languages_helper: languages_helper,
      options: languages_helper.getOptions(),
      reading_importance: false,
      writing_importance: false,
      verbal_importance: false
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils.getAllLanguages().then(languages => {
        this.languages = languages
      })
      if (this.payload.is_create) {
        this.setForm({
          id: ''
        })
        return
      }
      this.$network_utils.getPositionLanguage({ position_id: this.payload.position_id, position_language_id: this.payload.data.id, current_company_id: this.payload.company_id })
        .then(response => {
          this.setForm(response)
          this.reading_importance = response.reading_importance == 8
          this.writing_importance = response.writing_importance == 8
          this.verbal_importance = response.verbal_importance == 8
        })
    },
    submit () {
      this.form.data.language.fields.reading_importance.value = this.reading_importance ? 8 : 2
      this.form.data.language.fields.writing_importance.value = this.writing_importance ? 8 : 2
      this.form.data.language.fields.verbal_importance.value = this.verbal_importance ? 8 : 2
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      this.is_loading = true
      response.promise.then((response) => {
        this.$network_utils.sendPositionUpdateEvent({ position_id: this.payload.position_id, company_id: this.payload.company_id, status: this.payload.position_status })
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'success' })
        this.remove(this.payload)
      })
    },
    setForm (form_data) {
      this.form = new this.$form({
        language: {
          fields: {
            language_id: {
              value: form_data.language_id,
              has_error: false,
              validations: []
            },
            reading: {
              value: form_data.reading,
              has_error: false,
              validations: []
            },
            writing: {
              value: form_data.writing,
              has_error: false,
              validations: []
            },
            verbal: {
              value: form_data.verbal,
              has_error: false,
              validations: []
            },
            reading_importance: {
              value: form_data.reading_importance,
              has_error: false,
              validations: []
            },
            writing_importance: {
              value: form_data.writing_importance,
              has_error: false,
              validations: []
            },
            verbal_importance: {
              value: form_data.verbal_importance,
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: this.payload.is_create ? 'post' : 'put',
            url: '/positions/' + this.payload.position_id + '/languages/' + form_data.id,
            extra_data: {
              current_company_id: this.payload.company_id
            },
            headers: 'company_headers'
          },
          is_used: true
        }
      })
    },
    ...mapMutations('modals', ['remove'])
  },
  components: {
    Checkbox
  }
}
</script>
